/**
 * @generated SignedSource<<dbab1230537087deb3b0fac4692f1977>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type discountCodeCreateSingle_DiscountActionFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "discountCodeCreateSingle_DiscountActionFragment";
};
export type discountCodeCreateSingle_DiscountActionFragment$key = {
  readonly " $data"?: discountCodeCreateSingle_DiscountActionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"discountCodeCreateSingle_DiscountActionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "discountCodeCreateSingle_DiscountActionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "DiscountAction",
  "abstractKey": null
};

(node as any).hash = "198df45187c4e6d0f2fac0f96fd2e7a3";

export default node;
